import { html, node } from 'wirejs-dom/v2';
import { ProFeatures } from '../../services';
import { PricingTable } from './pricing-table';
import Alert from './alert';
import Tracker from '../navigation/tracker';

const tracker = new Tracker();

/**
 * @typedef {('advanced-analysis-tools' | 'core-llm-integration')} FeatureName
 */

/**
 * @typedef {object} ProContentArgs
 * @property {FeatureName | FeatureName[]} feature - The feature this content is tied to.
 * @property {string | HTMLElement | (() => string) | (() => HTMLElement)} content - The content to show when the customer has the given subscription level.
 * @property {string | HTMLElement | (() => string) | (() => HTMLElement)} upgradeContent - The description content to show when the customer does *not* have the required subscription.
 */


/**
 * 
 * @param {{
 * 	text: string
 * }} param0 
 */
export const UpgradeButton = function({ text = 'Upgrade!' } = {}) {
	/**
	 * 
	 * @param {Record<string, boolean>} userFeatures 
	 * @returns 
	 */
	async function startUpgrade() {
		const upgradeMessage = html`<div>
			${node('content', html`<h3>Checking for latest discounts ... ⏳ ...</h3>`)}
		</div>`.onadd(async () => {
			upgradeMessage.data.content = PricingTable();
		});

		new Alert({
			message: upgradeMessage,
			closeButton: "Nevermind. My decks are already perfect.",
			style: `
				width: min(30rem, 90vw);
				border-color: darkgreen;
			`
		});

		tracker.track('mtg_upgrade_start');
	};

	return html`<button onclick=${startUpgrade}>${text}</button>`;
};

/**
 * @param {ProContentArgs} args
 */
const ProContent = function({
	feature,
	content,
	upgradeContent,
}) {
	const features = Array.isArray(feature) ? feature : [feature];
	const defaultUpgrade = "Upgrade to use this feature.";
	const upgradeMessage =
		(typeof upgradeContent === 'function' ? upgradeContent() : upgradeContent)
		|| defaultUpgrade;

	const upgrade = typeof upgradeMessage === 'string' ?
		() => html`<span>${upgradeMessage}</span>` :
		() => upgradeMessage
	;

	const element = html`
		<db:procontent>
			${node('content', html`<span>...</span>`)}
		</db:procontent>
	`.extend(self => ({
		async refresh() {
			const userFeatures = await ProFeatures.getFeatures();
			const userHasFeatures = features.every(feature => userFeatures[feature]);
			self.data.content = userHasFeatures ? (
				typeof content === 'function' ? content() : content
			) : upgrade();
		}
	})).onadd(self => {
		self.refresh();
	});

	return element;
};

export default ProContent;
